import { authInstance, crcInstance, tiInstance } from "../../Axios";

export const searchTitresApi = (payload) => {
  let searchObject = payload?.searchObject;

  let fromCreationDate =
    searchObject?.tiDto?.fromDateCreation?.replaceAll("/", "-") || "";
  let toCreationDate =
    searchObject?.tiDto?.toDateCreation?.replaceAll("/", "-") || "";

  let fromDateDomiciliation =
    searchObject?.tiDto?.fromDateDomiciliation?.replaceAll("/", "-") || "";
  let toDateDomiciliation =
    searchObject?.tiDto?.toDateDomiciliation?.replaceAll("/", "-") || "";

  return tiInstance
    .get(
      `/api/titre-importations?numEnregistrement=${
        searchObject?.tiDto?.numEnr
      }&typeTitreImportationId=${
        searchObject?.tiDto?.idCategorie
      }&typeEtatTitreImportationId=${
        searchObject?.tiDto?.idEtat
      }&modificationStatutId=${
        searchObject?.tiDto?.idStatusModif
      }&typeMessageId=${searchObject?.tiDto?.idTypeMessage}&factureReference=${
        searchObject?.tiDto?.refFact
      }&dateCreationDu=${fromCreationDate}&dateCreationAu=${toCreationDate}&dateTransfertDu=&dateTransfertAu=&banqueId=${
        searchObject?.tiDto?.idBanque
      }&guichetId=${searchObject?.tiDto?.idGuichet}&declarantId=${
        searchObject?.tiDto?.idDeclarant
      }&nomenclatureDouaniereId=${
        searchObject?.tiDto?.idNomenclature
      }&operateurExpImpId=${
        searchObject?.tiDto?.idImportateur
      }&typeReglementId=${
        searchObject?.tiDto?.idReglement
      }&apurementSituationId=${
        searchObject?.tiDto?.idApurement
      }&dateDomiciliationDu=${fromDateDomiciliation}&dateDomiciliationAu=${toDateDomiciliation}&numeroDomiciliation=${
        searchObject?.tiDto?.numDom
      }&filterUser=${!searchObject?.modeConsultation}&searchClicked=true&pageNumber=${
        searchObject?.pagination?.page
      }&pageSize=${searchObject?.pagination?.pageSize}`,
      {}
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const exportTitresApi = (payload) => {
  let searchObject = payload?.searchObject;

  let fromCreationDate =
    searchObject?.tiDto?.fromDateCreation?.replaceAll("/", "-") || "";
  let toCreationDate =
    searchObject?.tiDto?.toDateCreation?.replaceAll("/", "-") || "";

  let fromDateDomiciliation =
    searchObject?.tiDto?.fromDateDomiciliation?.replaceAll("/", "-") || "";
  let toDateDomiciliation =
    searchObject?.tiDto?.toDateDomiciliation?.replaceAll("/", "-") || "";
  return tiInstance
    .get(
      `/api/export-excel?numEnregistrement=${searchObject?.tiDto?.numEnr}&typeTitreImportationId=${searchObject?.tiDto?.idCategorie}&typeEtatTitreImportationId=${searchObject?.tiDto?.idEtat}&modificationStatutId=${searchObject?.tiDto?.idStatusModif}&typeMessageId=${searchObject?.tiDto?.idTypeMessage}&factureReference=${searchObject?.tiDto?.refFact}&dateCreationDu=${fromCreationDate}&dateCreationAu=${toCreationDate}&dateTransfertDu=&dateTransfertAu=&banqueId=${searchObject?.tiDto?.idBanque}&guichetId=${searchObject?.tiDto?.idGuichet}&declarantId=${searchObject?.tiDto?.idDeclarant}&nomenclatureDouaniereId=${searchObject?.tiDto?.idNomenclature}&operateurExpImpId=${searchObject?.tiDto?.idImportateur}&typeReglementId=${searchObject?.tiDto?.idReglement}&apurementSituationId=${searchObject?.tiDto?.idApurement}&dateDomiciliationDu=${fromDateDomiciliation}&dateDomiciliationAu=${toDateDomiciliation}&numeroDomiciliation=${searchObject?.tiDto?.numDom}&searchClicked=true&pageNumber=${searchObject?.pagination?.page}&pageSize=${searchObject?.pagination?.pageSize}`,
      {}
    )
    .then((response) => {
      const url = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data?.content}`;
      const fileName = "Titres";
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      return "";
    })
    .catch((e) => {
      throw e;
    });
};

export const searchGuichetsApi = (payload) => {
  let searchObject = payload?.payload;

  let localite = searchObject?.localite.replaceAll(/['()]/g, "%27");
  return tiInstance
    .get(
      `/api/guichets?code=${searchObject?.code}&direction=${searchObject?.adresse}&description=${searchObject?.nom}&banque=${searchObject?.idBanque}&localite=${localite}&pageNumber=${searchObject?.pageNumber}&pageSize=${searchObject?.pageSize}`,
      {}
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const searchImportateursApi = (payload) => {
  let searchObject = payload?.payload;

  return tiInstance
    .get(
      `/api/importateurs?code=${searchObject?.code}&description=${searchObject?.description}&codePIN=${searchObject?.codePIN}&centreRC=${searchObject?.centreRC}&numeroRC=${searchObject?.numeroRC}&ice=${searchObject?.ice}&ifu=${searchObject?.ifu}&pageNumber=${searchObject?.pageNumber}&pageSize=${searchObject?.pageSize}`,
      {}
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const searchNomenclaturesApi = (payload) => {
  let searchObject = payload?.payload;

  return tiInstance
    .get(
      `/api/nomenclatures-douanieres?code=${searchObject?.code}&description=${
        searchObject?.description
      }&typeTI=${searchObject?.typeTI}&typeTe=${
        searchObject?.typeTE
      }&pageNumber=${searchObject?.pageNumber || "0"}&pageSize=${
        searchObject?.pageSize || "5"
      }`,
      {}
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const searchDeclarantsApi = (payload) => {
  let searchObject = payload?.payload;

  return tiInstance
    .get(
      `/api/transitaires?code=${searchObject?.code}&description=${searchObject?.description}&centreRc=${searchObject?.centreRc}&numRc=${searchObject?.numeroRc}&ice=${searchObject?.ice}&ifu=${searchObject?.ifu}&pageNumber=${searchObject?.pageNumber}&pageSize=${searchObject?.pageSize}`,
      {}
    )
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getEtatsApi = () => {
  return tiInstance
    .get(`/api/etats`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getLocalitesApi = () => {
  return tiInstance
    .get(`/api/localites`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getCategoriesApi = () => {
  return tiInstance
    .get(`/api/types-ti`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getStatusModifApi = () => {
  return tiInstance
    .get(`/api/statuts-modification`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTypeMessageApi = () => {
  return tiInstance
    .get(`/api/types-message`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getBanqueApi = () => {
  return tiInstance
    .get(`/api/banques`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTypeReglementApi = () => {
  return tiInstance
    .get(`/api/types-reglement`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getModeReglementApi = () => {
  return tiInstance
    .get(`/api/modalites-paiement`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiApurementApi = () => {
  return tiInstance
    .get(`/api/situation-apurement`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTypeTEApi = () => {
  return tiInstance
    .get(`/api/types-te`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTypeTIApi = () => {
  return tiInstance
    .get(`/api/types-ti`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiByIdApi = (payload) => {
  if (payload?.mode === "CONSULTER") {
    return tiInstance
      .get(`api/titre-importation/${payload.id}`)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        throw e;
      });
  } else if (payload?.mode === "GESTION") {
    return tiInstance
      .get(`api/mce/visa/${payload.id}`)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        throw e;
      });
  } else if (payload?.mode === "PROLONGATION") {
    return tiInstance
      .get(`api/mce/prolongation/departements/${payload.id}`)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        throw e;
      });
  } else if (payload?.mode === "GESTION_DEP") {
    return tiInstance
      .get(`api/mce/visa/autre-departements/${payload.id}`)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        throw e;
      });
  } else if (payload?.mode === "REGL") {
    return tiInstance
      .get(`api/banque/suivi-reglement/${payload.id}`)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        throw e;
      });
  }
};

export const downloadTiApi = (payload) => {
  return tiInstance
    .get(`api/print?idTitre=${payload.id}`)
    .then((response) => {
      const url = `data:application/pdf;base64,${response.data?.content}`;
      const fileName = `${response.data?.fileName}`;
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const downloadTiFactureDocumentApi = (payload) => {
  return tiInstance
    .get(`api/documents/${payload.guId}/${payload.parentId}`)
    .then((response) => {
      if (payload.action === "SHOW") {
        return response;
      } else if (payload.action === "DOWNLOAD") {
        const url = `data:application/pdf;base64,${response.data?.content}`;
        const fileName = `${response.data?.fileName}`;
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        return null;
      }
    })
    .catch((e) => {
      throw e;
    });
};

export const downloadTiDocumentApi = (payload) => {
  return tiInstance
    .get(`api/documents/${payload.guId}/${payload.parentId}`)
    .then((response) => {
      if (payload.action === "SHOW") {
        return response;
      } else if (payload.action === "DOWNLOAD") {
        const url = `data:application/pdf;base64,${response.data?.content}`;
        const fileName = `${response.data?.fileName}`;
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();
        return null;
      }
    })
    .catch((e) => {
      throw e;
    });
};

export const getHistoriqueApi = (payload) => {
  return tiInstance
    .get(`api/titre-importation/historiques?idTitreImportation=${payload.id}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiDepartmentsApi = () => {
  return tiInstance
    .get(`/api/departements`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const transferTiApi = (payload) => {
  return tiInstance
    .post(`/api/mce/transfert`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const transferTiProlongApi = (payload) => {
  return tiInstance
    .post(`/api/mce/transfert/prolongation`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiDecisionTypeMCEApi = () => {
  return tiInstance
    .get(`/api/decisions-mce`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const TiDecisionMCEApi = (payload) => {
  return tiInstance
    .post(`/api/mce/decision`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const TiDecisionDEPApi = (payload) => {
  return tiInstance
    .post(`/api/mce/decision/departements`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiDecisionTypeMCEProlongApi = () => {
  return tiInstance
    .get(`/api/reponses-titre`, {})
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const TiProlongMCEApi = (payload) => {
  return tiInstance
    .post(`/api/mce/decision-prolongation`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const TiProlongDEPApi = (payload) => {
  return tiInstance
    .post(`/api/mce/decision-prolongation/departements`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const postTiColumnsDensityStateApi = (payload) => {
  return tiInstance
    .post(`/api/etatTableTitreImportation/`, payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const getTiColumnsDensityStateApi = () => {
  return tiInstance
    .get(`/api/etatTableTitreImportation/`, {
      params: {
        projectName: "BNK/",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const fetchKpiTiApi = (payload) => {
  return tiInstance
    .get(`api/kpi?year=${payload.year}`)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};

export const AuthentificationApi = (payload) => {
  return authInstance
    .post(`/signIn`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const registerMFAApi = (payload) => {
  return authInstance
    .post(`/registerMFA`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const sendOtpMailApi = (payload) => {
  return authInstance
    .post(`/sendOtpMail`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw new Error(e.toString());
    });
};

export const postChangePasswordApi = (payload) => {
  return crcInstance
    .put(`/api/user/changePassword`, payload.payload)
    .then((response) => {
      return { success: true, data: response.data };
    })
    .catch((error) => {
      return {
        success: false,
        error: error.response
          ? error.response.data
          : "An unknown error occurred",
      };
    });
};

export const getReponseDomiciliationBanqueDataApi = (id) => {
  return tiInstance.get(`/api/banque/demande-domiciliation/${id}`);
};

export const acceptDomiciliationBanqueApi = (data) => {
  return tiInstance.post(`/api/banque/acceptation`, data);
};

export const refuseDomiciliationBanqueApi = (data) => {
  return tiInstance.post(`/api/banque/refus`, data);
};

export const postDonnesReglementsApi = (payload) => {
  return tiInstance
    .post(`/api/banque/donnees-reglement`, payload.payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      throw e;
    });
};
